import {IServiceFamily} from "@/model/ServiceFamily/ServiceFamily"

export interface IHasServiceFamily {
    setServiceFamily(serviceFamily: IServiceFamily): void
    getServiceFamily(): IServiceFamily | null
}

function hasServiceFamily<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServiceFamily {
        private serviceFamily: IServiceFamily | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getServiceFamily(): IServiceFamily | null {
            return this.serviceFamily
        }
        public setServiceFamily(serviceFamily: IServiceFamily) {
            this.serviceFamily = serviceFamily
        }
    };
}

export default hasServiceFamily